<template>
  <div class="container mx-2">
    <!-- Breadcrumb  -->
    <va-card>
      <va-card-content>
        <div style="display: flex">
          <va-breadcrumbs color="primary">
            <va-breadcrumbs-item :label="$t('menu.users')" />
            <va-breadcrumbs-item :label="$t('menu.editors')" />
          </va-breadcrumbs>
        </div>
      </va-card-content>
    </va-card>
    <va-inner-loading :loading="loading" icon="restart_alt">
      <div class="mt-3">
        <div class="flex">
          <va-card stripe stripe-color="primary">
            <va-card-content>
              <div
                class="col align--center justify--space-evenly"
                style="height: 35vh"
                v-if="editors.length == 0"
              >
                <h1 style="font-size: 32px">
                  {{ $t("no_editors") }}
                  <span class="material-icons px-2" size="32px">
                    edit_off
                  </span>
                </h1>
                <va-button
                  class="float-end"
                  color="#01377f"
                  flat
                  @click="showAddModal = true"
                >
                  <span class="material-icons"> add </span>
                  {{ $t("add") + " " + $t("menu.editors") }}
                </va-button>
              </div>
              <va-list v-else>
                <va-button
                  color="#01377f"
                  class="mb-4"
                  @click="showAddModal = true"
                >
                  <span class="material-icons"> add </span>
                  {{ $t("add") }}
                </va-button>
                <va-list-item
                  v-for="(editor, index) in editors"
                  :key="editor.name"
                  to=""
                >
                <strong>{{ index + offset + 1 }}.</strong>
                  <va-list-item-section avatar class="px-3">
                    <va-avatar>
                      <img v-if="editor.img" :src="editor.img" />
                      <div v-else>{{ editor.name.substring(0, 1) }}</div>
                    </va-avatar>
                  </va-list-item-section>

                  <va-list-item-section>
                    <va-list-item-label>
                      {{ editor.name }}
                    </va-list-item-label>

                    <va-list-item-label caption :lines="index + 1">
                      {{ editor.tel }}
                    </va-list-item-label>

                    <va-list-item-label caption :lines="index + 1">
                      {{ editor.email }}
                    </va-list-item-label>
                  </va-list-item-section>

                  <va-list-item-section icon>
                    <va-button flat @click="deleteEditor(editor.id)">
                      <va-icon name="trash" color="danger" />
                    </va-button>
                  </va-list-item-section>
                </va-list-item>
              </va-list>
              <va-pagination
                v-if="pages > 1"
                color="#0a4695"
                style="direction: ltr"
                class="float-end"
                v-model="currentPage"
                :visible-pages="3"
                :pages="pages"
              />
            </va-card-content>
          </va-card>
        </div>
      </div>
    </va-inner-loading>
    <!-- Add editor modal -->
    <va-modal
      v-model="showAddModal"
      :title="$t('add') + ' ' + $t('menu.editors')"
      hide-default-actions
      fullscreen
      mobile-fullscreen
    >
      <add-editor-form />
    </va-modal>
  </div>
</template>

<script>
import { request, gql } from "graphql-request";
import AddEditorForm from "./components/AddEditorForm.vue";
export default {
  components: { AddEditorForm },
  data() {
    return {
      showAddModal: false,
      editors: [],
      editorsCount: null,
      pages: null,
      currentPage: 1,
      limit: 10,
      offset: 0,
      loading: true,
    };
  },
  async created() {
    // Pagination Logic
    try {
      const editorS_COUNT = gql`
        query {
          UsersCount(where: { user_role_id: 4 }) {
            count
          }
        }
      `;
      const counterResponse = await request(
        this.$store.state.appUrl,
        editorS_COUNT
      );
      this.editorsCount = counterResponse.UsersCount.count;
      this.pages = Math.ceil(this.editorsCount / this.limit);
      this.geteditors();
    } catch (error) {
      this.loading = false;
      console.log(error);
      this.$swal
        .fire({
          icon: "warning",
          title: this.$t("errors.network"),
          text: "Try Again in a minute",
          confirmButtonColor: "#023b81",
          confirmButtonText: "Reload",
        })
        .then((result) => {
          if (result.value) {
            location.reload();
          }
        });
    }
  },
  methods: {
    async geteditors() {
      this.offset = (this.currentPage - 1) * this.limit;
      const GET_EDITORS = gql`
        query ($limit: Int, $offset: Int) {
          editors: Users(
            where: { user_role_id: 4 }
            limit: $limit
            offset: $offset
          ) {
            id
            name
            email
            tel
          }
        }
      `;
      try {
        const response = await request(this.$store.state.appUrl, GET_EDITORS, {
          limit: this.limit,
          offset: this.offset,
        });
        this.editors = response.editors;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$swal
          .fire({
            icon: "warning",
            title: this.$t("errors.network"),
            text: "Try Again in a minute",
            confirmButtonColor: "#023b81",
            confirmButtonText: "Reload",
          })
          .then((result) => {
            if (result.value) {
              location.reload();
            }
          });
      }
    },
    async deleteEditor(id) {
      const DELETE_EDITOR = gql`
        mutation ($id: Int!) {
          UsersDelete(id: $id)
        }
      `;
      this.$swal
        .fire({
          title: this.$t("sure?"),
          text: this.$t("delete_text"),
          icon: "question",
          showCancelButton: true,

          confirmButtonColor: "#e42222",
          confirmButtonText: this.$t("delete"),
          cancelButtonText: this.$t("cancel"),
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            try {
              const response = await request(
                this.$store.state.appUrl,
                DELETE_EDITOR,
                { id }
              );
              if (response.UsersDelete) {
                this.$swal.fire({
                  icon: "success",
                  title: this.$t("success"),
                  text: this.$t("delete_editor_success"),
                  confirmButtonColor: "#023b81",
                  confirmButtonText: this.$t("ok"),
                });
                this.geteditors();
              } else {
                this.$swal.fire({
                  icon: "danger",
                  title: this.$t("failed"),
                  text: this.$t("delete_editor_fail"),
                  confirmButtonColor: "#023b81",
                  confirmButtonText: this.$t("ok"),
                });
              }
            } catch (error) {
              console.log(error);
            }
          }
        });
    },
  },
  provide() {
    return {
      getEditors: this.geteditors,
    };
  },
};
</script>

<style>
.va-list-item-section {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
</style>
